import Vue from 'vue'
import Router from 'vue-router'
import DashboardSummary from '@/components/dashboard/Dashboard.vue'
import CreateAdmin from '@/components/dashboard/CreateAdmin.vue'
import CreateOrUpdateConversation from '@/components/conversation/createOrUpdateConversation.vue'
import ViewApps from '@/components/conversation/view.vue'
import Login from '@/components/Login.vue'
import Callback from '@/components/callback.vue'
import NewNudge from '@/components/nudge/new.vue'
import ViewAllNudges from '@/components/nudge/view.vue'
import ViewANudge from '@/components/nudge/viewANudge.vue'
/**
 * Routes Added by Sarang
 */
import KeywordsList from '@/components/keyword-management/keywordsList.vue'
import MessagesDashboard from '@/components/messages-dashboard/messageSheet.vue'
import AddOrUpdateSheet from '@/components/messages-dashboard/addOrUpdate.vue'
import NewKeywordsDetails from '@/components/keyword-management/NewKeywordsDetails.vue'
// Application mEssahe dashboard routes
import SaveorEditSheet from '@/components/messages-dashboard/appmessageupdate.vue'
import AppmessagedDetails from '@/components/messages-dashboard/appMessagedetails.vue'

import VirtualResourcesList from '@/components/resources-management/virtual/virtualList.vue'
import VirtualResourcesAddOrUpdate from '@/components/resources-management/virtual/addOrUpdateResources.vue'
import LocateResources from '@/components/resources-management/locateResources.vue'
import BulkUploadPhysicalResources from '@/components/resources-management/physical/bulkUploadResources.vue'

import CustomerList from '@/components/customer-management/customerList.vue'
import CustomerAddOrUpdate from '@/components/customer-management/addOrUpdateCustomer.vue'
import PhysicalResourcesList from '@/components/resources-management/physical/physicalList.vue'

import LinkList from '@/components/link-management/linkList.vue'
import LinkAddOrUpdate from '@/components/link-management/addOrUpdateLink.vue'

import Opportunity from '@/components/opportunity-management/createOrUpdateOpportunity'
import OpportunityList from '@/components/opportunity-management/opportunityList.vue'
import OpportunityReport from '@/components/opportunity-management/opportunityReport.vue'
import DbMReport from '@/components/opportunity-management/databaseMarketingReport.vue'

import AudienceBuilder from '@/components/audience-builder/index.vue'
import AudienceList from '@/components/audience-builder/listQueries/index.vue'
import AudienceFolder from '@/components/audience-builder/manageFolder/index.vue'
import AudienceUpload from '@/components/audience-builder/audienceUpload/index.vue'
import AiAudienceBuilder from '@/components/audience-builder/ai-audience/index.vue'

import ReengagementManager from '@/components/reengagement-manager/reengagementList.vue'
import CreateReengagement from '@/components/reengagement-manager/createOrUpdateReengagement.vue'

import OfferingList from '@/components/offerings/offeringList.vue'
import OfferingAddOrUpdate from '@/components/offerings/createOrUpdateOffering.vue'

import UserJourneyView from '@/components/user-journey/userjourneyView.vue'
import CreateOrUpdateJourney from '@/components/user-journey/createOrUpdateJourney.vue'
import CreateNewJourney from '@/components/user-journey/CreateNewJourney.vue'
import JourneySettings from '@/components/user-journey/JourneySettings.vue'
import ChatSimulator from '@/components/chat-simulator/ChatSimulator.vue'

import CreateOrUpdateNudgeTemplate from '@/components/nudge-template-manager/createOrUpdateNudgeTemplate.vue'
import NudgeTemplateView from '@/components/nudge-template-manager/nudgeTemplateList.vue'

import fhiuserupload from '@/components/user-upload/index.vue'

import DatasetList from '@/components/auditing/index.vue'
import DatasetAudit from '@/components/auditing/audit.vue'
import DatasetEvaluate from '@/components/auditing/evaluate.vue'

import PhrasesList from '@/components/phrase-management/phrasesList.vue'
import PhrasesDetails from '@/components/phrase-management/PhraseDetails.vue'

import ScoutJORList from '@/components/scout-JOR-mapping/scoutJORMappingList.vue'
import ScoutJORDetails from '@/components/scout-JOR-mapping/scoutJORMappingDetails.vue'

import nlpTopicList from '@/components/nlp-topic-mapping/nlpTopicMappingList.vue'
import nlpTopicDetails from '@/components/nlp-topic-mapping/nlpTopicMappingDetails.vue'

import fileUpload from '@/components/file-upload/index.vue'

import { requireAuth } from '../../utils/auth'

import mediaList from '@/components/media-management/mediaList.vue'
import mediaUpload from '@/components/media-management/createOrUpdateMedia.vue'

import PromptList from '@/components/prompt-management/promptList.vue'
import PromptDetails from '@/components/prompt-management/createOrUpdatePrompt.vue'

import EntryPoints from '@/components/entry-points/EntryPoints.vue'
import NudgeDashboard from '@/components/nudge-console/NudgeDashboard.vue'
import CreateCampaign from '@/components/nudge-console/CreateCampaign.vue'
import NudgeAnalytics from '@/components/nudge-console/NudgeAnalytics.vue'
import EditCampaign from '@/components/nudge-console/EditCampaign.vue'
import NotificationsPage from '@/components/notifications/NotificationsPage.vue'
import CreateTemplate from '@/components/nudge-console/CreateTemplate.vue'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/callback',
      name: 'Callback',
      component: Callback
    },
    {
      path: '/summary',
      name: 'summary',
      beforeEnter: requireAuth,
      component: DashboardSummary
    },
    {
      path: '/createadmin',
      name: 'CreateAdmin',
      beforeEnter: requireAuth,
      component: CreateAdmin
    },
    {
      path: '/conversation/create',
      beforeEnter: requireAuth,
      component: CreateOrUpdateConversation
    },
    {
      path: '/conversation/update',
      beforeEnter: requireAuth,
      component: CreateOrUpdateConversation
    },
    {
      path: '/conversation/view',
      beforeEnter: requireAuth,
      component: ViewApps
    },
    {
      path: '/new-nudge',
      beforeEnter: requireAuth,
      component: NewNudge
    },
    {
      path: '/nudges',
      beforeEnter: requireAuth,
      component: ViewAllNudges
    },
    {
      path: '/nudge',
      beforeEnter: requireAuth,
      component: ViewANudge
    },
    {
      path: '/keywords_list',
      name: '/KeywordDashboard',
      beforeEnter: requireAuth,
      component: KeywordsList
    },
    {
      path: '/NewKeywordsDetails',
      name: '/NewKeywordsDetails',
      beforeEnter: requireAuth,
      component: NewKeywordsDetails
    },
    {
      path: '/phrases_list',
      name: '/PhraseDashboard',
      beforeEnter: requireAuth,
      component: PhrasesList
    },
    {
      path: '/PhrasesDetails',
      name: '/PhrasesDetails',
      beforeEnter: requireAuth,
      component: PhrasesDetails
    },
    {
      path: '/media-management/view',
      name: 'media-management/view',
      beforeEnter: requireAuth,
      component: mediaList
    },
    {
      path: '/media-management/upload',
      name: 'media-management/upload',
      beforeEnter: requireAuth,
      component: mediaUpload
    },
    {
      path: '/prompt-management/view',
      name: 'prompt-management/view',
      beforeEnter: requireAuth,
      component: PromptList
    },
    {
      path: '/prompt-management/create',
      name: 'prompt-management/create',
      beforeEnter: requireAuth,
      component: PromptDetails
    },
    {
      path: '/prompt-management/update',
      name: 'prompt-management/update',
      beforeEnter: requireAuth,
      component: PromptDetails
    },
    {
      path: '/messages-dashboard',
      beforeEnter: requireAuth,
      component: MessagesDashboard
    },
    {
      path: '/addOrUpdate',
      beforeEnter: requireAuth,
      component: AddOrUpdateSheet
    },
    {
      path: '/appmessageupdate',
      beforeEnter: requireAuth,
      component: SaveorEditSheet
    },
    {
      path: '/appMessagedetails',
      beforeEnter: requireAuth,
      component: AppmessagedDetails
    },
    {
      path: '/resources-virtual',
      name: '/resources-virtual',
      beforeEnter: requireAuth,
      component: VirtualResourcesList
    },
    {
      path: '/locate-resources',
      name: '/locate-resources',
      beforeEnter: requireAuth,
      component: LocateResources
    },
    {
      path: '/resources-physical',
      name: '/resources-physical',
      beforeEnter: requireAuth,
      component: PhysicalResourcesList
    },
    {
      path: '/virtual-resources-addOrUpdate',
      name: '/virtual-resources-addOrUpdate',
      beforeEnter: requireAuth,
      component: VirtualResourcesAddOrUpdate
    },
    {
      path: '/bulk-upload-physical-resources',
      name: 'bulk-upload-physical-resources',
      beforeEnter: requireAuth,
      component: BulkUploadPhysicalResources
    },
    {
      path: '/customer-list',
      name: '/customer-list',
      beforeEnter: requireAuth,
      component: CustomerList
    },
    {
      path: '/customer-addOrUpdate',
      name: '/customer-addOrUpdate',
      beforeEnter: requireAuth,
      component: CustomerAddOrUpdate
    },
    {
      path: '/link-list',
      name: '/link-list',
      beforeEnter: requireAuth,
      component: LinkList
    },
    {
      path: '/link-addOrUpdate',
      name: '/link-addOrUpdate',
      beforeEnter: requireAuth,
      component: LinkAddOrUpdate
    },
    {
      path: '/audience-builder/create',
      name: 'audience-builder/create',
      beforeEnter: requireAuth,
      component: AudienceBuilder
    },
    {
      path: '/audience-builder/update',
      name: 'audience-builder/update',
      beforeEnter: requireAuth,
      component: AudienceBuilder
    },
    {
      path: '/audience-builder/view',
      name: 'audience-builder/view',
      beforeEnter: requireAuth,
      component: AudienceList
    },
    {
      path: '/audience-builder/upload',
      name: 'audience-builder/upload',
      beforeEnter: requireAuth,
      component: AudienceUpload
    },
    {
      path: '/audience-builder/manage-folder',
      name: '/audience-builder/manage-folder',
      beforeEnter: requireAuth,
      component: AudienceFolder
    },
    {
      path: '/audience-builder/ai-generate',
      name: 'audience-builder/ai-generate',
      beforeEnter: requireAuth,
      component: AiAudienceBuilder
    },
    {
      path: '/opportunity-list',
      name: 'opportunity-list',
      beforeEnter: requireAuth,
      component: OpportunityList
    },
    {
      path: '/opportunity',
      name: 'opportunity',
      beforeEnter: requireAuth,
      component: Opportunity
    },
    {
      path: '/opportunity/:opportunityId?',
      name: 'opportunityDetails',
      beforeEnter: requireAuth,
      component: Opportunity
    },
    {
      path: '/opportunity/:opportunityId?/:action?',
      name: 'opportunityDetails',
      beforeEnter: requireAuth,
      component: Opportunity
    },
    {
      path: '/opportunity-report',
      name: 'OpportunityReport',
      beforeEnter: requireAuth,
      component: OpportunityReport
    },
    {
      path: '/dbm-reports',
      name: 'DbMReport',
      beforeEnter: requireAuth,
      component: DbMReport
    },
    {
      path: '/reengagement-manager/view',
      name: 'reengagement-manager/view',
      beforeEnter: requireAuth,
      component: ReengagementManager
    },
    {
      path: '/reengagement-manager/create',
      name: 'reengagement-manager/create',
      beforeEnter: requireAuth,
      component: CreateReengagement
    },
    {
      path: '/reengagement-manager/:campaignId?',
      name: 'campaignDetails',
      beforeEnter: requireAuth,
      component: CreateReengagement
    },
    {
      path: '/offering-manager/view',
      name: 'offering-manager/view',
      beforeEnter: requireAuth,
      component: OfferingList
    },
    {
      path: '/offering-manager/create',
      name: 'offering-manager/create',
      beforeEnter: requireAuth,
      component: OfferingAddOrUpdate
    },
    {
      path: '/offering-manager/update',
      name: 'offering-manager/update',
      beforeEnter: requireAuth,
      component: OfferingAddOrUpdate
    },
    {
      path: '/user-journey/view',
      name: 'user-journey/view',
      beforeEnter: requireAuth,
      component: UserJourneyView
    },
    {
      path: '/user-journey/create',
      name: 'user-journey/create',
      beforeEnter: requireAuth,
      component: CreateOrUpdateJourney
    },
    {
      path: '/user-journey/update',
      name: 'user-journey/update',
      beforeEnter: requireAuth,
      component: CreateOrUpdateJourney
    },
    {
      path: '/user-journey/create-new',
      name: 'user-journey/create-new',
      beforeEnter: requireAuth,
      component: CreateNewJourney,
      meta: { hideNav: true }
    },
    {
      path: '/user-journey/chat-simulator',
      name: 'user-journey/chat-simulator',
      beforeEnter: requireAuth,
      component: ChatSimulator,
      meta: { hideNav: true }
    },
    {
      path: '/user-journey/settings',
      name: 'user-journey/settings',
      beforeEnter: requireAuth,
      component: JourneySettings
    },
    {
      path: '/scout_jor_list',
      name: 'scout_jor_list',
      beforeEnter: requireAuth,
      component: ScoutJORList
    },
    {
      path: '/scout_jor_detail',
      name: 'scout_jor_detail',
      beforeEnter: requireAuth,
      component: ScoutJORDetails
    },
    {
      path: '/nlp_topic_list',
      name: 'nlp_topic_list',
      beforeEnter: requireAuth,
      component: nlpTopicList
    },
    {
      path: '/nlp_topic_detail',
      name: 'nlp_topic_detail',
      beforeEnter: requireAuth,
      component: nlpTopicDetails
    },
    {
      path: '/nudge-template/view',
      name: 'nudge-template/view',
      beforeEnter: requireAuth,
      component: NudgeTemplateView
    },
    {
      path: '/nudge-template/create',
      name: 'nudge-template/create',
      beforeEnter: requireAuth,
      component: CreateOrUpdateNudgeTemplate
    },
    {
      path: '/nudge-template/update',
      name: 'nudge-template/update',
      beforeEnter: requireAuth,
      component: CreateOrUpdateNudgeTemplate
    },
    {
      // AI Nudge Creation: the standalone WhatsApp template chat (Templates PRD 3.3).
      path: '/nudge-template/ai-create',
      name: 'nudge-template/ai-create',
      beforeEnter: requireAuth,
      component: CreateTemplate
    },
    {
      path: '/user-upload/create',
      name: 'user-upload/create',
      beforeEnter: requireAuth,
      component: fhiuserupload
    },
    {
      path: '/auditing/symptoms',
      name: 'Symptoms',
      beforeEnter: requireAuth,
      component: DatasetList
    },
    {
      path: '/auditing/medications',
      name: 'Medications',
      beforeEnter: requireAuth,
      component: DatasetList
    },
    {
      path: '/auditing/chat-intent',
      name: 'Chat Intent',
      beforeEnter: requireAuth,
      component: DatasetList
    },
    {
      path: '/auditing/audit/:datasetId',
      name: 'Audit Dataset',
      beforeEnter: requireAuth,
      component: DatasetAudit
    },
    {
      path: '/auditing/evaluate/:datasetId',
      name: 'Audit Dataset',
      beforeEnter: requireAuth,
      component: DatasetEvaluate
    },
    {
      path: '*',
      name: 'Not Exists',
      beforeEnter: requireAuth,
      redirect: '/'
    },
    {
      path: '/file-upload/create',
      name: 'file-upload/create',
      beforeEnter: requireAuth,
      component: fileUpload
    },
    {
      path: '/entry-points/create',
      name: 'entry-points/create',
      beforeEnter: requireAuth,
      component: EntryPoints
    },
    {
      path: '/nudge-console/dashboard',
      name: 'nudge-console/dashboard',
      beforeEnter: requireAuth,
      component: NudgeDashboard
    },
    {
      path: '/nudge-console/create-campaign',
      name: 'nudge-console/create-campaign',
      beforeEnter: requireAuth,
      component: CreateCampaign
    },
    {
      path: '/nudge-console/analytics',
      name: 'nudge-console/analytics',
      beforeEnter: requireAuth,
      component: NudgeAnalytics
    },
    {
      // Reached from the Dashboard's Edit action; ?campaignId= names the campaign. Not in
      // the nav — there is nothing to edit until you have picked a campaign.
      path: '/nudge-console/edit-campaign',
      name: 'nudge-console/edit-campaign',
      beforeEnter: requireAuth,
      component: EditCampaign
    },
    {
      // Reached from the bell's "View all notifications" (in the top bar, not the nav).
      path: '/notifications',
      name: 'notifications',
      beforeEnter: requireAuth,
      component: NotificationsPage
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js